import { useEffect, useState } from 'react';

// Оформление интерфейса: тема (светлая / тёмная / авто) и «Упрощённый вид» (без blur, статичный фон, без декоративных анимаций).
// Хранится в браузере пользователя; применяется атрибутами на <html>: data-theme, data-lite.
// Те же правила дублирует короткий скрипт в public/index.html, чтобы тема применялась до первой отрисовки (без вспышки).
const THEME_KEY = 'miko-theme';
const LITE_KEY = 'miko-lite';
export const THEMES = ['light', 'dark', 'system'];

const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { localStorage.setItem(k, v); } catch { /* приватный режим: настройка не сохранится */ } };

export const getThemeMode = () => { const v = read(THEME_KEY); return THEMES.includes(v) ? v : 'system'; };
// Очень слабые устройства (≤2 ядра или ≤2 ГБ памяти) получают упрощённый вид по умолчанию, пока пользователь сам не выбрал
export const getLite = () => {
  const v = read(LITE_KEY);
  if (v === '1') return true;
  if (v === '0') return false;
  const n = typeof navigator !== 'undefined' ? navigator : {};
  return (n.hardwareConcurrency > 0 && n.hardwareConcurrency <= 2) || (n.deviceMemory > 0 && n.deviceMemory <= 2);
};
const systemDark = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
export const resolveTheme = (mode) => (mode === 'system' ? (systemDark() ? 'dark' : 'light') : mode);

const listeners = new Set();
// Публичные страницы клиентов (форма лида /f/, отзыв /r/) оформляет организация: они всегда светлые
const isPublicPage = () => /^\/(f|r)\//.test(window.location.pathname);

export function applyAppearance() {
  const root = document.documentElement;
  root.setAttribute('data-theme', isPublicPage() ? 'light' : resolveTheme(getThemeMode()));
  root.setAttribute('data-lite', getLite() ? 'true' : 'false');
  listeners.forEach((fn) => fn());
}
export function setThemeMode(mode) { write(THEME_KEY, THEMES.includes(mode) ? mode : 'system'); applyAppearance(); }
export function setLite(on) { write(LITE_KEY, on ? '1' : '0'); applyAppearance(); }

// Следим за сменой системной темы, пока выбран режим «Авто»
if (typeof window !== 'undefined' && window.matchMedia) {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => { if (getThemeMode() === 'system') applyAppearance(); };
  mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener && mq.addListener(onChange);
}

export function useAppearance() {
  const [, force] = useState(0);
  useEffect(() => { const fn = () => force((n) => n + 1); listeners.add(fn); return () => listeners.delete(fn); }, []);
  return { mode: getThemeMode(), theme: resolveTheme(getThemeMode()), lite: getLite(), setThemeMode, setLite };
}
